// src/layouts/support/Support.js
import React from "react";
import { Container, Typography, Link, Box } from "@mui/material";

export default function Support() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom>
        Support
      </Typography>
      <Typography paragraph>Besoin d’aide ? Contactez-nous :</Typography>
      <Box sx={{ mb: 2 }}>
        <Typography>
          Email : <Link href="mailto:support@budgycraft.com">support@budgycraft.com</Link>
        </Typography>
        <Typography>
          Documentation légale : <Link href="/legal/privacy">Privacy</Link>
          {" · "}
          <Link href="/legal/terms">Terms</Link>
          {" · "}
          <Link href="/legal/eula">EULA</Link>
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary">
        Incluez si possible le tenant (<code>company</code>), l’heure, et l’action. Nous pourrons
        corréler avec <code>intuit_tid</code> si nécessaire.
      </Typography>
    </Container>
  );
}
